import PropTypes from 'prop-types';
import { Field } from 'formik';
import MaterialTextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  field: {
    margin: theme.spacing(1, 0, 2, 0),
    display: 'block',
  },
}));

const TextField = ({ name, label, disabled, touched, helperText, ...fieldProps }) => {
  const classes = useStyles();
  return (
    <Field name={name}>
      {({ field, form }) => (
        <MaterialTextField
          id={name}
          label={label}
          {...field}
          value={field.value || ''}
          error={(touched || form.touched[field.name]) && Boolean(form.errors[field.name])}
          helperText={
            ((touched || form.touched[field.name]) && form.errors[field.name]) ||
            helperText
          }
          fullWidth
          disabled={disabled}
          variant="outlined"
          className={classes.field}
          {...fieldProps}
        />
      )}
    </Field>
  );
};

TextField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  helperText: PropTypes.node
};

export default TextField;
